import React, { useEffect, useMemo, useState, useRef } from 'react';
import Button from '@web-common/components/UI/Button';
import { Modal } from 'antd';
import message from '@web-common/components/UI/Message/SiriusMessage';
import LoadingOutlined from '@ant-design/icons/LoadingOutlined';
import { apiHolder as api, apis, util, } from 'api';
import { useActions, useAppDispatch, useAppSelector } from '@web-common/state/createStore';
import store from '@web-common/state/createStore';
import { actions as mailActions } from '@web-common/state/reducer/mailReducer';
import { AppActions } from '@web-common/state/reducer';
import { currentMailSize as getCurrentMailSize } from '@web-common/state/getter';
import { trackSendMail, replaceCurrentMailContent } from './utils';
import { verifyEmail, mailHiddenText, remWaittingId, getSendMailReceiverRoleByEmails } from '../../util';
import style from './index.module.scss';
import TaskMailOutDomain from './TaskMailOutDomain';
import { sizeTransform } from '@web-common/utils/file';
import SendIcon from '@web-common/components/UI/Icons/svgs/SendSvg';
import { getIn18Text } from 'api';
import HiddenTxtModal from './HiddenTxtModal';
import useMsgRenderCallback from '@web-common/hooks/useMsgRenderCallback';
import useCreateCallbackForEvent from '@web-common/hooks/useCreateCallbackForEvent';
import { checkboxConfirm } from '@web-mail/common/components/CheckboxModal/CheckboxModal';
import { MAIL_WRITE_GUIDE_LOCAL_KEY, MAIL_WRITE_HOTKEY_LOCAL_KEY } from '@web-mail/common/constant';
import { tabType } from '@web-common/state/reducer/mailTabReducer';
import { getMailContentText } from '@web-mail/util';
const systemApi = api.api.getSystemApi();
const contactApi = api.api.requireLogicalApi(apis.contactApiImpl);
const mailConfApi = api.api.requireLogicalApi(apis.mailConfApiImpl);
const productAuthApi = api.api.requireLogicalApi(apis.productAuthApiImpl);
const accountApi = api.api.requireLogicalApi(apis.accountApiImpl);
const storeApi = api.api.getDataStoreApi();
const eventApi = api.api.getEventApi();
const mailPlusCustomerApi = api.api.requireLogicalApi(apis.mailPlusCustomerApiImpl);
const loggerApi = api.api.requireLogicalApi(apis.loggerApiImpl);
const writeTabTypes = [
    tabType.reply,
    tabType.replyAll,
    tabType.forward,
    tabType.writeCommon,
    tabType.replyWithAttach,
    tabType.replyAllWithAttach,
    tabType.forwardAsAttach,
    tabType.edit,
    tabType.editDraft,
];
const IGNORE_KEYS = 'IGNORE_KEYS';
const SendValidateComp = (props) => {
    var _a, _b, _c, _d, _e;
    const { sendLoading, tooltipVisible, scheduledSent, setTooltipVisible, saveSend, editorInstance } = props;
    const { currentMail, mails } = useAppSelector(state => state.mailReducer);
    const receiver = useAppSelector(state => state.mailReducer.currentMail.receiver);
    const currentMailId = useAppSelector(state => state.mailReducer.currentMail.cid);
    const attachments = useAppSelector(state => state.attachmentReducer.attachments);
    const readRemind = useAppSelector(state => state.mailReducer.currentMail.senderReceivers);
    const puretext = useAppSelector(state => { var _a; return (_a = state.mailReducer.currentMail.status) === null || _a === void 0 ? void 0 : _a.puretext; });
    const curTabTyps = useAppSelector(state => { var _a; return (_a = state.mailTabReducer.currentTab) === null || _a === void 0 ? void 0 : _a.type; });
    const errModalData = useAppSelector(state => state.mailReducer.errModalData);
    const requestReadReceipt = useMemo(() => currentMail === null || currentMail === void 0 ? void 0 : currentMail.requestReadReceipt, [currentMail]);
    const conferenceShow = (_a = currentMail.status) === null || _a === void 0 ? void 0 : _a.conferenceShow;
    const praiseMailShow = (_b = currentMail.status) === null || _b === void 0 ? void 0 : _b.praiseMailShow;
    const taskMailShow = (_c = currentMail.status) === null || _c === void 0 ? void 0 : _c.taskMailShow;
    const priority = (_d = currentMail === null || currentMail === void 0 ? void 0 : currentMail.entry) === null || _d === void 0 ? void 0 : _d.priority;
    const isOneRcpt = (_e = currentMail === null || currentMail === void 0 ? void 0 : currentMail.entry) === null || _e === void 0 ? void 0 : _e.isOneRcpt;
    const useVariable = useAppSelector(state => { var _a, _b; return (_b = (_a = state.mailReducer.currentMail) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.useVariable; });
    const curUseVariableRef = useRef(undefined);
    const dispatch = useAppDispatch();
    const [afterConfirm, setAfterConfirm] = useState(['']);
    const [ignoreList, setIgnoreList] = useState([]);
    const subAccountExpired = useMemo(() => currentMail === null || currentMail === void 0 ? void 0 : currentMail.subAccountExpired, [currentMail]);
    const [outDomainReceiver, setOutDomainReceiver] = useState([]);
    const [taskMailOutDomainVisible, setTaskMailOutDomainVisible] = useState(false);
    const scheduleDate = useAppSelector(state => state.mailReducer.currentMail.scheduleDate);
    const scheduleDateTimeZone = useAppSelector(state => state.mailReducer.currentMail.scheduleDateTimeZone);
    const [hiddenTxtVisible, setHiddenTxtVisible] = useState(false);
    const mailEditStatus = useAppSelector(state => state.mailReducer.currentMail.mailEditStatus);
    const sendClickAble = useMemo(() => {
        const { mailEditStatus } = currentMail;
        if (mailEditStatus && ['delivering', 'saving', 'reUploading', 'reGenerating'].includes(mailEditStatus))
            return false;
        if (subAccountExpired)
            return false;
        if (tooltipVisible)
            return false;
        if (sendLoading)
            return false;
        return true;
    }, [currentMail, subAccountExpired, tooltipVisible, sendLoading]);
    const [currentMailMailListMap, setCurrentMailMailListMap] = useState({
        id: {},
        mail: {},
    });
    const [hiddenTxt, setHiddenTxt] = useState('');
    const sendBtnText = useMemo(() => {
        if (scheduledSent)
            return getIn18Text('DINGSHIFASONG');
        if (currentMail.isDyncGroupSend)
            return getIn18Text('YULANBINGFS');
        return getIn18Text('FASONG');
    });
    const appActions = useActions(AppActions);
    const commandStr = util.getCommonTxt();
    useEffect(() => {
        if (!tooltipVisible) {
            if (afterConfirm[afterConfirm.length - 1] === 'title') {
                appActions.doFocusTitle(true);
            }
            setAfterConfirm([]);
            dispatch(mailActions.doCoverErrModalData({ errModalMailId: undefined }));
        }
    }, [tooltipVisible]);
    useEffect(() => {
        curUseVariableRef.current = useVariable;
    }, [useVariable]);
    useEffect(() => {
        storeApi.get(IGNORE_KEYS).then(({ suc, data }) => {
            if (suc && data && data.includes('ignoreAttachment')) {
                const ignoreListSet = new Set(ignoreList);
                ignoreListSet.add('ignoreAttachment');
                setIgnoreList([...ignoreListSet]);
            }
        });
    }, []);
    const confirmTaskMail = () => {
        const receiverAccountName = outDomainReceiver.map(item => item.contact.contact.accountName);
        const filterReveivers = receiver.filter(item => { var _a, _b; return !receiverAccountName.includes((_b = (_a = item === null || item === void 0 ? void 0 : item.contact) === null || _a === void 0 ? void 0 : _a.contact) === null || _b === void 0 ? void 0 : _b.accountName); });
        appActions.doReplaceReceiver(filterReveivers);
        if (filterReveivers.length === 0) {
            return;
        }
        saveSend({ receiver: filterReveivers });
    };
    const taskMailValidate = (mailListMap, curMail) => {
        const { receiver, entry, cid } = curMail;
        if (!(receiver === null || receiver === void 0 ? void 0 : receiver.some(item => item.mailMemberType === 'to'))) {
            dispatch(mailActions.doCoverErrModalData({
                errModalMailId: cid,
                errorText: getIn18Text('WUFAFASONG\uFF0C11'),
                isSimpleTooltip: true,
            }));
            setTooltipVisible(true);
            return true;
        }
        let title = (entry === null || entry === void 0 ? void 0 : entry.title) || '';
        title = title.replace(/\s+/g, '');
        if (!title && !afterConfirm.includes('title')) {
            dispatch(mailActions.doCoverErrModalData({
                errModalMailId: cid,
                errorText: getIn18Text('WUFAFASONG\uFF0C12'),
                isSimpleTooltip: true,
            }));
            setTooltipVisible(true);
            return true;
        }
        if (existOutDomain(mailListMap)) {
            return true;
        }
        return false;
    };
    const praiseMailValidate = (curMail) => {
        var _a;
        const praiseMail = curMail.praiseMail;
        if (!((_a = praiseMail === null || praiseMail === void 0 ? void 0 : praiseMail.winners) === null || _a === void 0 ? void 0 : _a.length)) {
            message.info({
                content: getIn18Text('QINGTIANJIABIAOYANG'),
            });
            return true;
        }
        if (!(praiseMail === null || praiseMail === void 0 ? void 0 : praiseMail.medalId)) {
            message.info({
                content: getIn18Text('QINGBANFAXUNZHANG'),
            });
            return true;
        }
        if (!(praiseMail === null || praiseMail === void 0 ? void 0 : praiseMail.presentationWords)) {
            message.info({
                content: getIn18Text('QINGSHURUBANJIANG11'),
            });
            return true;
        }
        if (!(praiseMail === null || praiseMail === void 0 ? void 0 : praiseMail.presenter)) {
            message.info({
                content: getIn18Text('QINGSHURUBANJIANG'),
            });
            return true;
        }
        return false;
    };
    const existOutDomain = (mailListMap) => {
        const currentUser = systemApi.getCurrentUser();
        if (currentUser) {
            const currentUserDomain = currentUser.domain;
            const receiverDiff = receiver.filter(item => {
                const domain = getContactDomain(item.contact);
                const isMailList = item.contactItem.type === 'external' ? mailListMap.mail[item === null || item === void 0 ? void 0 : item.contactItem.contactItemVal] : mailListMap.id[item === null || item === void 0 ? void 0 : item.contact.contact.id];
                return domain !== currentUserDomain || isMailList;
            });
            if (receiverDiff.length) {
                setOutDomainReceiver(receiverDiff);
                setTaskMailOutDomainVisible(true);
                return true;
            }
        }
        return false;
    };
    const getContactDomain = (contact) => {
        const accountName = contact.contact.accountName;
        return accountName.split('@')[1];
    };
    const validdateDownloadErrorImg = () => {
        var _a, _b;
        const content = (_b = (_a = currentMail === null || currentMail === void 0 ? void 0 : currentMail.entry) === null || _a === void 0 ? void 0 : _a.content) === null || _b === void 0 ? void 0 : _b.content;
        if (content.includes('data-lxdownloadimg-error')) {
            return true;
        }
        return false;
    };
    const valideUploadingImg = () => {
        var _a, _b;
        const content = (_b = (_a = currentMail === null || currentMail === void 0 ? void 0 : currentMail.entry) === null || _a === void 0 ? void 0 : _a.content) === null || _b === void 0 ? void 0 : _b.content;
        if (content.includes('paste-img-reload hide')) {
            return true;
        }
        return false;
    };
    const validateUnfinishImg = () => {
        var _a, _b;
        const content = (_b = (_a = currentMail === null || currentMail === void 0 ? void 0 : currentMail.entry) === null || _a === void 0 ? void 0 : _a.content) === null || _b === void 0 ? void 0 : _b.content;
        if (content.includes('paste-img-title') || content.includes('paste-img-reload')) {
            return true;
        }
        return false;
    };
    const attachmentValidate = (params) => {
        const { currentAttachments, curSendId } = params;
        const faildedFiles = currentAttachments.filter(item => item.status === 'fail');
        if (faildedFiles.length) {
            const allFilesNameString = faildedFiles.map(item => item.fileName).join('、');
            const ellpsisLength = 50;
            const ellpsisAllFilesNameString = allFilesNameString.length > ellpsisLength ? allFilesNameString.slice(0, ellpsisLength) + '...' : allFilesNameString;
            message.fail({
                content: getIn18Text('CUNZAISHANGCHUANSHI') + '：' + ellpsisAllFilesNameString,
            });
            return false;
        }
        if (currentAttachments.some(item => (item === null || item === void 0 ? void 0 : item.status) && ['uploading', 'copying'].includes(item === null || item === void 0 ? void 0 : item.status))) {
            dispatch(mailActions.doAddWaittingMailIds([curSendId]));
            return false;
        }
        return true;
    };
    const expireAttValidate = (params) => {
        const { currentAttachments, curSendId } = params;
        const nowTime = new Date().getTime();
        const expireExist = currentAttachments.some(item => {
            const { expired } = item;
            if (typeof expired === 'number') {
                if (expired === 0)
                    return false;
                if (expired < nowTime)
                    return true;
                return false;
            }
            return false;
        });
        if (!expireExist)
            return true;
        dispatch(mailActions.doCoverErrModalData({
            errModalMailId: curSendId,
            errorText: getIn18Text('FUJIANBAOHANBUCUNZAI'),
            isSimpleTooltip: false,
        }));
        setTooltipVisible(true);
        setAfterConfirm([...afterConfirm, 'attExpired']);
        return false;
    };
    const sendValidate = useCreateCallbackForEvent(async (params) => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        const { continueSend } = params || {};
        const storeStateForLog = store.getState();
        loggerApi.track('send_validate_enter', {
            currentMailId,
            mailEditStatus,
            storeMailStatus: ((_b = (((_a = storeStateForLog === null || storeStateForLog === void 0 ? void 0 : storeStateForLog.mailReducer) === null || _a === void 0 ? void 0 : _a.mails) || []).find((m) => m.cid === currentMailId)) === null || _b === void 0 ? void 0 : _b.mailEditStatus) ||
                ((_d = (_c = storeStateForLog === null || storeStateForLog === void 0 ? void 0 : storeStateForLog.mailReducer) === null || _c === void 0 ? void 0 : _c.currentMail) === null || _d === void 0 ? void 0 : _d.mailEditStatus),
            continueSend: !!continueSend,
        });
        trackSendMail({
            receiver,
            attachments,
            readRemind: !!readRemind,
            conferenceShow,
            taskMailShow,
            praiseMailShow,
            scheduledSent,
            priority,
            isOneRcpt,
            puretext,
            requestReadReceipt,
        });
        if (!systemApi.isNetworkAvailable()) {
            message.fail({ content: getIn18Text('CAOZUOSHIBAI\uFF0C') });
            return;
        }
        if (!(receiver === null || receiver === void 0 ? void 0 : receiver.length)) {
            message.warn({ content: getIn18Text('QINGTIANXIESHOUJIAN') });
            return;
        }
        const receiverError = receiver === null || receiver === void 0 ? void 0 : receiver.filter(item => { var _a, _b; return !verifyEmail(((_b = (_a = item === null || item === void 0 ? void 0 : item.contactItem) === null || _a === void 0 ? void 0 : _a.contactItemVal) === null || _b === void 0 ? void 0 : _b.trim()) || ''); });
        if (receiverError === null || receiverError === void 0 ? void 0 : receiverError.length) {
            const msg = receiverError.length === 1 ? getIn18Text('YOUXIANGDEZHICUO') : getIn18Text('CUNZAICUOWUDE');
            message.warn({ content: msg });
            return;
        }
        if (taskMailShow) {
            const doGetContactInMailListParams = {
                idList: [],
                emailList: [],
            };
            receiver.forEach(contact => {
                if (contact.contactItem.type === 'external') {
                    doGetContactInMailListParams.emailList.push(contact.contactItem.contactItemVal);
                }
                else {
                    doGetContactInMailListParams.idList.push(contact.contact.contact.id);
                }
            });
            doGetContactInMailListParams.idList = doGetContactInMailListParams.idList.filter(_ => _);
            doGetContactInMailListParams.emailList = doGetContactInMailListParams.emailList.filter(_ => _);
            let mailListMap = { id: {}, mail: {} };
            if (doGetContactInMailListParams.idList.length || doGetContactInMailListParams.emailList.length) {
                try {
                    mailListMap = await contactApi.doGetContactInMailList(doGetContactInMailListParams);
                    setCurrentMailMailListMap(mailListMap);
                }
                catch (error) {
                    return false;
                }
            }
            if (taskMailValidate(mailListMap, currentMail))
                return;
        }
        if (praiseMailShow && praiseMailValidate(currentMail))
            return;
        if (!((_e = currentMail === null || currentMail === void 0 ? void 0 : currentMail.entry) === null || _e === void 0 ? void 0 : _e.title) && !afterConfirm.includes('title')) {
            dispatch(mailActions.doCoverErrModalData({
                errModalMailId: currentMailId,
                errorText: getIn18Text('YOUJIANWU\u201CZHU'),
                isSimpleTooltip: false,
            }));
            setAfterConfirm([...afterConfirm, 'title']);
            setTooltipVisible(true);
            return;
        }
        if (((_h = (_g = (_f = currentMail === null || currentMail === void 0 ? void 0 : currentMail.entry) === null || _f === void 0 ? void 0 : _f.content) === null || _g === void 0 ? void 0 : _g.content) === null || _h === void 0 ? void 0 : _h.length) === 0 && !afterConfirm.includes('content')) {
            setAfterConfirm([...afterConfirm, 'content']);
            dispatch(mailActions.doCoverErrModalData({
                errModalMailId: currentMailId,
                errorText: getIn18Text('YOUJIANWU\u201CZHENG'),
                isSimpleTooltip: false,
            }));
            setTooltipVisible(true);
            return;
        }
        if (curUseVariableRef.current) {
            const isSub = await accountApi.isSubAccount(currentMail.optSenderMainEmail);
            if (isSub) {
                dispatch(mailActions.doCoverErrModalData({
                    errModalMailId: currentMailId,
                    errorText: getIn18Text('FEIZHUYOUXGZYXZBZCFS15'),
                    isSimpleTooltip: false,
                    continueCallback: () => {
                        curUseVariableRef.current = false;
                        dispatch(mailActions.doUseVariable(false));
                    },
                }));
                setTooltipVisible(true);
                return;
            }
        }
        if (process.env.BUILD_ISEDM) {
            const emails = receiver.map(item => { var _a; return (_a = item === null || item === void 0 ? void 0 : item.contactItem) === null || _a === void 0 ? void 0 : _a.contactItemVal; }) || [];
            const isInvaildRole = await getSendMailReceiverRoleByEmails(emails);
            if (isInvaildRole) {
                message.warn('存在禁止发信邮箱!');
                return;
            }
        }
        if (!ignoreList.includes('ignoreAttachment')) {
            const replacedContent = replaceCurrentMailContent((_k = (_j = currentMail === null || currentMail === void 0 ? void 0 : currentMail.entry) === null || _j === void 0 ? void 0 : _j.content) === null || _k === void 0 ? void 0 : _k.content, ['style', 'blockquote']).replace(/(<.+?)style=".+?"(.*?>)/g, '$1$2');
            const content = getMailContentText({ content: replacedContent, removeSign: true, removeUnSubText: true });
            const htmlContent = new DOMParser().parseFromString(content || '', 'text/html');
            const contentAttachExecRes = /附件|attachments|attachment/.exec(htmlContent.body.innerText);
            const titleAttachExecRes = /附件|attachments|attachment/.exec((_l = currentMail === null || currentMail === void 0 ? void 0 : currentMail.entry) === null || _l === void 0 ? void 0 : _l.title);
            const attachExecRes = contentAttachExecRes || titleAttachExecRes;
            if (attachExecRes &&
                attachExecRes.filter(v => v) &&
                !attachments.some(attachment => attachment.mailId === currentMail.cid) &&
                !afterConfirm.includes('attachment')) {
                dispatch(mailActions.doCoverErrModalData({
                    errModalMailId: currentMailId,
                    errorText: getIn18Text('YOUJIANZHONGTIJI'),
                    isSimpleTooltip: false,
                    showCheckbox: true,
                    checkboxChecked: false,
                    checkboxType: 'ignoreAttachment',
                }));
                setAfterConfirm([...afterConfirm, 'attachment']);
                setTooltipVisible(true);
                return;
            }
        }
        if (scheduledSent && scheduleDate) {
            const moment8 = systemApi.timeZoneTrans(scheduleDate, scheduleDateTimeZone || 0, 8);
            if (moment8) {
                if (new Date().getTime() / 1000 - moment8.unix() > 0) {
                    dispatch(mailActions.doCoverErrModalData({
                        errModalMailId: currentMailId,
                        errorText: getIn18Text('DINGSHIFASONGSHI'),
                        isSimpleTooltip: true,
                    }));
                    setTooltipVisible(true);
                    return;
                }
            }
        }
        if (currentMail.setEncrypt) {
            if (!currentMail.entry.encpwd || !/^[a-zA-Z0-9]{6,16}$/.test(currentMail.entry.encpwd)) {
                dispatch(mailActions.doCoverErrModalData({
                    errModalMailId: currentMailId,
                    errorText: getIn18Text('JIAMIMIMABIXS6WSZ、ZMZC，ZMXQFDXX'),
                    isSimpleTooltip: true,
                }));
                setTooltipVisible(true);
                return;
            }
        }
        let errorText = '';
        let errorDoc = '';
        if (validdateDownloadErrorImg()) {
            errorText = getIn18Text('SENDMAIL_DOWNLOADIMGERROR_TITLE');
            errorDoc = getIn18Text('SENDMAIL_DOWNLOADIMGERROR_CONTENT');
        }
        if (!errorText && validateUnfinishImg()) {
            errorText = getIn18Text('SENDMAIL_UPLOADERROR_TITLE');
            errorDoc = getIn18Text('SENDMAIL_UPLOADERROR_CONTENT');
        }
        if (!errorText && valideUploadingImg()) {
            errorText = getIn18Text('SENDMAIL_UPLOADINGERROR_TITLE');
            errorDoc = getIn18Text('SENDMAIL_UPLOADINGERROR_CONTENT');
        }
        if (errorText && errorText.length) {
            dispatch(mailActions.doCoverErrModalData({
                errModalMailId: currentMailId,
                errorText: errorText,
                errorDoc: errorDoc,
                isSimpleTooltip: true,
            }));
            setTooltipVisible(true);
            return;
        }
        const currentAttachments = attachments.filter(item => item.mailId === currentMailId && item.type !== 'download');
        const attachmentValidateRes = attachmentValidate({ currentAttachments, curSendId: currentMailId });
        if (!attachmentValidateRes)
            return;
        const currentMailSize = getCurrentMailSize(currentMail, attachments);
        const mailLimit = mailConfApi.getMailLimit({ _account: (currentMail === null || currentMail === void 0 ? void 0 : currentMail.initSenderStr) || '' });
        if (currentMailSize > mailLimit.smtp_max_send_mail_size) {
            const curVersionId = await productAuthApi.asyncGetProductVersionId({ _account: currentMail === null || currentMail === void 0 ? void 0 : currentMail.initSenderStr });
            if (curVersionId === 'free') {
                eventApi.sendSysEvent({
                    eventName: 'upgradeVersion',
                    eventData: { cid: currentMailId },
                });
            }
            else {
                Modal.error({
                    title: getIn18Text('FASONGSHIBAI，YJZDX（ZW+FJ）CG') + mailLimit.smtp_max_send_mail_size / 1024 / 1024 + 'M',
                    content: `当前大小为${sizeTransform(currentMailSize)}M，您可拆封为多封邮件发送`,
                    okText: getIn18Text('ZHIDAOLE'),
                    className: `${style.sizeErrorDialog}`,
                });
            }
            return false;
        }
        if (!afterConfirm.includes('attExpired')) {
            const expireAttVRes = expireAttValidate({ currentAttachments, curSendId: currentMailId });
            if (!expireAttVRes)
                return;
        }
        if (continueSend) {
            setTooltipVisible(false);
        }
        appActions.doModifyMailEditStatus({ cid: currentMailId, status: '' });
        if (currentMail.isDyncGroupSend) {
            appActions.doChangeDyncGroupSendPreview({ show: true, finishFun: () => sendReq() });
            return;
        }
        sendReq();
        return true;
    });
    const sendReq = () => {
        if (typeof curUseVariableRef.current === 'boolean') {
            saveSend({ useVariable: curUseVariableRef.current });
        }
        else {
            saveSend();
        }
    };
    const autoSendValidate = useCreateCallbackForEvent(async (curSendId) => {
        var _a, _b, _c;
        remWaittingId(curSendId);
        const storeState = store.getState();
        const targetMail = (((_a = storeState === null || storeState === void 0 ? void 0 : storeState.mailReducer) === null || _a === void 0 ? void 0 : _a.mails) || []).find((m) => m.cid === curSendId);
        const curEditStatus = (targetMail === null || targetMail === void 0 ? void 0 : targetMail.mailEditStatus) || ((_c = (_b = storeState === null || storeState === void 0 ? void 0 : storeState.mailReducer) === null || _b === void 0 ? void 0 : _b.currentMail) === null || _c === void 0 ? void 0 : _c.mailEditStatus);
        if (curEditStatus === 'delivering' || curEditStatus === 'success') {
            loggerApi.track('auto_send_blocked_by_status', {
                curSendId,
                curEditStatus,
                trigger: 'autoSendValidate',
            });
            return;
        }
        if (tooltipVisible) {
            message.fail({ content: '自动发信失败' });
            return;
        }
        const curMail = mails.find(item => item.cid === curSendId);
        if (!curMail)
            return;
        const { scheduleDate, scheduleDateTimeZone, entry } = curMail;
        if (!systemApi.isNetworkAvailable()) {
            message.fail({ content: getIn18Text('CAOZUOSHIBAI\uFF0C') });
            return;
        }
        if (scheduleDate) {
            const moment8 = systemApi.timeZoneTrans(scheduleDate, scheduleDateTimeZone || 0, 8);
            if (moment8) {
                if (new Date().getTime() / 1000 - moment8.unix() > 0) {
                    dispatch(mailActions.doCoverErrModalData({
                        errModalMailId: curSendId,
                        errorText: getIn18Text('DINGSHIFASONGSHI'),
                        isSimpleTooltip: true,
                    }));
                    setTooltipVisible(true);
                    return;
                }
            }
        }
        const currentMailSize = getCurrentMailSize(curMail, attachments);
        const mailLimit = mailConfApi.getMailLimit({ _account: (curMail === null || curMail === void 0 ? void 0 : curMail.initSenderStr) || '' });
        if (currentMailSize > mailLimit.smtp_max_send_mail_size) {
            const curVersionId = await productAuthApi.asyncGetProductVersionId({ _account: curMail === null || curMail === void 0 ? void 0 : curMail.initSenderStr });
            if (curVersionId === 'free') {
                eventApi.sendSysEvent({
                    eventName: 'upgradeVersion',
                    eventData: { cid: currentMailId },
                });
            }
            else {
                Modal.error({
                    title: getIn18Text('FASONGSHIBAI，YJZDX（ZW+FJ）CG') + mailLimit.smtp_max_send_mail_size / 1024 / 1024 + 'M',
                    content: `邮件${(entry === null || entry === void 0 ? void 0 : entry.title) || ''}大小为${sizeTransform(currentMailSize)}M，您可拆封为多封邮件发送`,
                    okText: getIn18Text('ZHIDAOLE'),
                    className: `${style.sizeErrorDialog}`,
                });
            }
            return false;
        }
        const currentAttachments = attachments.filter(item => item.mailId === curSendId && item.type !== 'download');
        const expireAttVRes = expireAttValidate({ currentAttachments, curSendId });
        if (!expireAttVRes)
            return;
        loggerApi.track('auto_send_validate_pass', {
            curSendId,
            trigger: 'autoSendValidate',
        });
        saveSend({ curSendId });
        return true;
    });
    const hiddenTxtValidate = useCreateCallbackForEvent(async () => {
        var _a, _b, _c, _d;
        remWaittingId(currentMailId);
        const storeState = store.getState();
        const storeMailStatus = ((_b = (((_a = storeState === null || storeState === void 0 ? void 0 : storeState.mailReducer) === null || _a === void 0 ? void 0 : _a.mails) || []).find((m) => m.cid === currentMailId)) === null || _b === void 0 ? void 0 : _b.mailEditStatus) || ((_d = (_c = storeState === null || storeState === void 0 ? void 0 : storeState.mailReducer) === null || _c === void 0 ? void 0 : _c.currentMail) === null || _d === void 0 ? void 0 : _d.mailEditStatus);
        loggerApi.track('hidden_txt_validate_enter', {
            currentMailId,
            mailEditStatus,
            storeMailStatus,
        });
        if (!editorInstance || storeMailStatus === 'delivering' || storeMailStatus === 'success')
            return;
        dispatch(mailActions.doModifyMailEditStatus({ cid: currentMailId, status: 'delivering' }));
        const valiHiddenTxt = mailHiddenText(editorInstance.getBody(), 'html');
        if (valiHiddenTxt) {
            setHiddenTxt(valiHiddenTxt);
            setHiddenTxtVisible(true);
            dispatch(mailActions.doModifyMailEditStatus({ cid: currentMailId, status: '' }));
            return;
        }
        const valiRes = await sendValidate();
        if (!valiRes) {
            dispatch(mailActions.doModifyMailEditStatus({ cid: currentMailId, status: '' }));
        }
    });
    const sendAction = useCreateCallbackForEvent((sendMailId, cond) => {
        if (sendMailId === currentMailId) {
            if (cond === 'continueSend') {
                dispatch(mailActions.doCoverErrModalData({
                    showCheckbox: false,
                    continueCallback: undefined,
                    calcelCallback: undefined,
                }));
                if ((errModalData === null || errModalData === void 0 ? void 0 : errModalData.checkboxType) === 'ignoreAttachment') {
                    if (!!(errModalData === null || errModalData === void 0 ? void 0 : errModalData.checkboxChecked)) {
                        storeApi.put(IGNORE_KEYS, 'ignoreAttachment');
                        setIgnoreList([...ignoreList, 'ignoreAttachment']);
                    }
                }
                sendValidate({ continueSend: true });
            }
            else {
                hiddenTxtValidate();
            }
        }
        else {
            autoSendValidate(sendMailId);
        }
    });
    useMsgRenderCallback('toSendMail', ev => {
        const { sendMailId, cond } = ev.eventData;
        sendAction(sendMailId, cond);
    });
    const isWriteMailTab = useMemo(() => {
        return writeTabTypes.includes(curTabTyps);
    }, [curTabTyps]);
    useMsgRenderCallback('mailMenuOper', ev => {
        if (ev.eventStrData === 'sendMail' && isWriteMailTab) {
            let canShowModal = true;
            let hkIsOpen = false;
            try {
                canShowModal = !localStorage.getItem(MAIL_WRITE_GUIDE_LOCAL_KEY);
                hkIsOpen = !!localStorage.getItem(MAIL_WRITE_HOTKEY_LOCAL_KEY);
            }
            catch (e) {
                console.error('[error] MAIL_WRITE_GUIDE_LOCAL_KEY', e);
            }
            if (canShowModal && !hkIsOpen) {
                const guideModal = checkboxConfirm({
                    title: getIn18Text('`SHIFOUKAIQIYJFSKJJ`') + `(${commandStr} ↩)`,
                    okText: getIn18Text('QUEDING'),
                    cancelText: getIn18Text('QUXIAO'),
                    closable: true,
                    isGlobal: true,
                    onCancel: () => {
                        guideModal.destroy();
                    },
                    onOk: (checked) => {
                        localStorage.setItem(MAIL_WRITE_HOTKEY_LOCAL_KEY, '1');
                        if (checked) {
                            localStorage.setItem(MAIL_WRITE_GUIDE_LOCAL_KEY, '1');
                        }
                        guideModal.destroy();
                        const modal = checkboxConfirm({
                            title: getIn18Text('QUERENFASONGYOUJ？（JXDJ↩JKFS）'),
                            okText: getIn18Text('QUEDING') + ' ↩',
                            cancelText: getIn18Text('QUXIAO') + ' Esc',
                            closable: true,
                            isGlobal: true,
                            autoFocusButton: 'ok',
                            showCheck: false,
                            onCancel: () => {
                                modal.destroy();
                            },
                            onOk: () => {
                                hiddenTxtValidate();
                                modal.destroy();
                            },
                        });
                        return false;
                    },
                });
            }
            else if (hkIsOpen) {
                const modal = checkboxConfirm({
                    title: getIn18Text('QUERENFASONGYOUJ？（JXDJ↩JKFS）'),
                    okText: getIn18Text('QUEDING') + ' ↩',
                    cancelText: getIn18Text('QUXIAO') + ' Esc',
                    closable: true,
                    isGlobal: true,
                    autoFocusButton: 'ok',
                    showCheck: false,
                    onCancel: () => {
                        modal.destroy();
                    },
                    onOk: () => {
                        hiddenTxtValidate();
                        modal.destroy();
                    },
                });
            }
        }
    });
    return (React.createElement(React.Fragment, null,
        React.createElement(Button, { id: "sendValidateComp", btnType: "primary", size: "small", inline: true, disabled: !sendClickAble, onClick: e => {
                e.stopPropagation();
                hiddenTxtValidate();
            } },
            React.createElement("span", null, sendBtnText),
            scheduledSent ? '' : mailEditStatus === 'delivering' ? React.createElement(LoadingOutlined, null) : React.createElement(SendIcon, null)),
        React.createElement(TaskMailOutDomain, { visible: taskMailOutDomainVisible, setVisible: setTaskMailOutDomainVisible, receiver: outDomainReceiver, confirm: confirmTaskMail, currentMailMailListMap: currentMailMailListMap }),
        React.createElement(HiddenTxtModal, { editorInstance: editorInstance, visible: hiddenTxtVisible, setVisible: setHiddenTxtVisible, hiddenTxt: hiddenTxt, handleCommentOk: sendValidate })));
};
export default SendValidateComp;
export const SendValidateCompClone = (props) => {
    const { sendLoading, tooltipVisible, scheduledSent } = props;
    const { currentMail } = useAppSelector(state => state.mailReducer);
    const subAccountExpired = useMemo(() => currentMail === null || currentMail === void 0 ? void 0 : currentMail.subAccountExpired, [currentMail]);
    const mailEditStatus = useMemo(() => currentMail === null || currentMail === void 0 ? void 0 : currentMail.mailEditStatus, [currentMail]);
    const sendClickAble = useMemo(() => {
        const { mailEditStatus } = currentMail;
        if (mailEditStatus && ['delivering', 'saving', 'reUploading', 'reGenerating'].includes(mailEditStatus))
            return false;
        if (subAccountExpired)
            return false;
        if (tooltipVisible)
            return false;
        if (sendLoading)
            return false;
        return true;
    }, [currentMail, subAccountExpired, tooltipVisible, sendLoading]);
    const sendBtnText = useMemo(() => {
        if (scheduledSent)
            return getIn18Text('DINGSHIFASONG');
        if (currentMail.isDyncGroupSend)
            return getIn18Text('YULANBINGFS');
        return getIn18Text('FASONG');
    }, [scheduledSent, currentMail]);
    const ckAction = (e) => {
        var _a;
        if (!sendClickAble)
            return;
        e.stopPropagation();
        (_a = document.getElementById('sendValidateComp')) === null || _a === void 0 ? void 0 : _a.click();
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Button, { btnType: "primary", size: "small", inline: true, disabled: !sendClickAble, onClick: e => ckAction(e) },
            React.createElement("span", null, sendBtnText),
            scheduledSent ? '' : mailEditStatus === 'delivering' ? React.createElement(LoadingOutlined, null) : React.createElement(SendIcon, null))));
};
